import a_gladchenko from '@/assets/a_gladchenko-a.png'
import g_andriishin from '@/assets/g_andriishin-a.png'
// import m_shakin from '@/assets/m_shakin-a.png'
// import p_presnyakov from '@/assets/p_presnyakov-a.png'
import r_antropov from '@/assets/r_antropov-a.png'
import v_chistilin from '@/assets/v_chistilin-a.png'
import e_biryukova from '@/assets/e_biryukova-a.png'
import m_fyodorova from '@/assets/m_fyodorova.png'

const andrishin = {
    name: {
        raw: 'Глеб Андриишин',
        komu: 'Глебу Андришину',
    },
    img: {
        src: g_andriishin,
    },
    description: 'Маркетолог',
    about: { 
        list: [
            'Опыт работы в SEO с 2019',
            'В ГЕО маркетинге с 2022',
            'Маркетолог в федеральной сети Мастер Минутка 2021-2023',
            'Маркетолог в Софтлайн 2023',
            'За 2 года работы с картами помогли увеличить посещаемость более 50 организациям по всей РФ',
            'Автор телеграм канала <a href="https://t.me/GlebSEO">@Gleg_SEO</a> (около 1500 подписчиков)'
        ],
    },
    uslugi: {
        title: '',
        header: '',
        footer: '',
        list: [
            {
                title: '',
                list: [
                    'ГЕО продвижение клиники на картах',
                    'Создание сайтов',
                    'SEO продвижение сайтов клиник',
                    'Создание приложений и софта',
                    'Личные консультации',
                ]
            }
        ]
    }
}

const fyodorova = {
    name: {
        raw: 'Малика Фёдорова',
        komu: 'Малике Фёдоровой', 
    },
    img: {
        src: m_fyodorova,
    },
    description: 'Основатель и главный врач “DMClinic”, врач дерматовенеролог, косметолог.',
    about: {

        list: [
            // 'Основатель и главный врач “DMClinic”, врач дерматовенеролог, косметолог.',
            'В косметологии с 2003 г.',
            'Спикер и докладчик на конференциях и конгрессах по эстетической медицине',
            'Сертифицированный тренер по инъекционным методикам',
            'Автор статей и публикаций в профессиональных журналах и интернет -площадках',
            'Побелитель Всероссийского профессионального конкурса «Award Enterestet  2025”',
            'Автор телеграм канала <a href="https://t.me/dmm_cosm">@dmm_cosm</a>',
        ]
    },
    uslugi: {
        // title: 'Провожу обучения индивидуальные и в минигруппах (актуально врачам и для клиник) по темам',
        list: [
            {
                // title: 'ss',
                list: [
                    // 'Индивидуальная постановка руки по ботулотоксину и филлерам. Разбор «сложных» лиц.',
                    'Индивидуальная постановка руки по ботулотоксину и филлерам. Разбор «сложных» лиц.',
                ]
            },
            {
                title: 'Провожу обучения индивидуальные и в минигруппах (актуально врачам и для клиник) по темам:',
                list: [
                    '«ЗВЁЗДНАЯ КОНСУЛЬТАЦИЯ ВРАЧА-КОСМЕТОЛОГА»<br>Как провести первичную консультацию, чтоб формировать запись на несколько месяцев вперед',
                    '«БОТУЛИНОТЕРАПИЯ с нуля до уровня профи»',
                    '«БИОРЕВИТАЛИЗАЦИЯ - королева или серый кардинал косметологии».<br>Все о препаратах и техниках.',
                    '«ПРОФЕССИОНАЛЬНЫЕ ЧИСТКИ ЛИЦА. Максимум эффективности - минимум травмы».<br>Все виды чисток. Как сделать чистку так, чтоб пациент к вам вернулся.',
                    '«Терапевтический RF-лифтинг с WOW эффектом»',
                ],
            },

        ]
    }
}

const chistilin = {
    name: {
        raw: 'Виктор Чистилин',
        komu: 'Виктору Чистилину',
    },
    img: {
        src: v_chistilin,
    },
    description: 'Руководитель TRINET.Medicine',
    about: {
        list: [
            'Врач по образованию, в 2003 г. закончил СПб ГПМА',
            'Автор книги "Витамины для сайта: руководство по развитию медицинских сайтов"',
            'Автор курса "Поисковая оптимизация сайта клиники"',
            'Спикер на медицинских конференциях',
            // 'Руководитель в TRINET.Medicine',
        ]
    },
    uslugi: {
        title: 'Чем могу быть полезен?',
        header: 'Помогаю клиникам привлекать новых пациентов с помощью комплексного подхода:',
        list: [
            {
                title: 'Сайт',
                list: [
                    'Разработка или доработка сайта клиники / персонального сайта врача',
                    'Аудит сайта с целью повышения конверсии',
                    'Проверка сайта на соответствие требованиям законодательства РФ — поможет избежать штрафов',
                ],
            },
            {
                title: 'SEO и аналитика',
                list: [
                    'Поисковое продвижение сайта в Яндекс и Google',
                    'SEO-аудит, технический аудит, юзабилити-аудит',
                ],
            },
            {
                title: 'Работа с внешними площадками',
                list: [
                    'Продвижение на медицинских агрегаторах: ПроДокторов, НаПоправку, СберЗдоровье — от аудита до вывода в ТОП',
                    'Работа с геосервисами: Яндекс.Бизнес, 2ГИС',
                    'Работа с сервисом Яндекс.Врачи',
                ],
            },
            {
                title: 'Контент и репутация',
                list: [
                    'Медицинский копирайтинг: тексты от авторов с мед. образованием',
                    'Работа с репутацией: настройка каналов для получения отзывов от пациентов на нужных площадках',
                ],
            },
            {
                title: 'Реклама и стратегия',
                list: [
                    'Контекстная и таргетированная реклама',
                    'Консультации по любым вопросам, связанным с привлечением пациентов',
                ],
            },
        ],
        footer: 'Да! И всё это я делаю не один — а вместе с командой экспертов, с которой мы работаем в медицинском маркетинге уже более 19 лет.',
    }
}

const gladchenko = {
    name: {
        raw: 'Антон Гладченко',
        komu: 'Антону Гладченко',
    },
    img: {
        src: a_gladchenko,
    },
    description: 'Руководитель Digital агентства BART, маркетолог.',
    about: { 
        list: [
            'Начинал со своей компании SkyApp Software.',
            'Опыт в маркетинге с 2008 года.',
            'Руководит агентством BART и выстраивает услугу комплексного продвижения.',
            'Продвигал стоматологии, клиники лечения от алкоголизма, косметологические проекты и даже медицинское оборудование.',
            'Автор телеграм-канала про маркетинг в b2b и ecommerce <a href="https://t.me/bossmarketer">@bossmarketer</a> (около 4000 подписчиков)',
        ],
    },
    uslugi: {
        title: 'Чем я могу вам помочь?',

        list:[
            {
                list: [
                    'Консультации по стратегии привлечения пациентов',
                    'Привлечение первичных пациентов через контекстную рекламу',
                    'Ведение рекламы Telegram Ads',
                    'SEO сайта клиники',
                    'Выстраивание сквозной аналитики для клиники ',
                    'Повышение конверсии сайта клиники',
                    'Продвижение врачей в Telegram',
                    'Рекламы статей в Яндекс Промостраницах',
                ]    
            }
        ],

    },
}

const biryukova = {
    name: {
        raw: 'Елена Бирюкоова',
        komu: 'Елене Бирюковой',
    },
    img: {
        src: e_biryukova,
    },
    description: 'Маркетолог, продюсер, сооснователь рекламного агентства Минтака',
    about: {
        list: [
            '12+ лет в медицинском маркетинге и продвижении экспертов',
            'Ведущая подкастов и спикер отраслевых мероприятий: Телемедфорум, Всероссийский конгресс пациентов, Медиаметрикс',
        ],
        footer: '<span class="h5">Я и моя команда помогаем сделать так, чтобы специалисты в сфере здоровья и красоты стали известными для своих пациентов.</span>\
        <ul class="__subplus"><li>Более 1000 пациентов нашли своих врачей за последний год благодаря нашей работе.</li>\
        <li>Почти 10 тыс репостов и сохранений набрали материалы, которые мы готовили для наших клиентов.</li>\
        <li>Более 10 млн просмотров экспертных роликов.</li></ul>\
        ',
    },
    uslugi: {
        title: 'Чем могу быть полезна?',
        header: '',
        list: [
            // {
            //     title: 'Я и моя команда помогаем сделать так, чтобы специалисты в сфере здоровья и красоты стали известными для своих пациентов.',
            //     list: [
            //         'Более 1000 пациентов нашли своих врачей за последний год благодаря нашей работе.',
            //         'Почти 10 тыс репостов и сохранений набрали материалы, которые мы готовили для наших клиентов.',
            //         'Более 10 млн просмотров экспертных роликов.',
            //     ]
            // },
            {

                title: 'Консультации и аудиты',
                list: [
                    'Консультации по развитию бренда в интернет пространстве',
                    'Аудит цифровых площадок и рекламных кабинетов',
                ]
            },
            {
                title: 'Стратегия и социальные сети',
                list: [
                    'Разработка диджитал-стратегии: план развития вашего бренда в сети.',
                    'Комплексное ведение в соцсетях врачей и клиник с минимальным участием экспертов',
                    'Настройка рекламы: ВКонтакте, Телеграм, Яндекс',
                    'Фото/видео съемка контента за 1 день на несколько месяцев',
                ]
            },
            {
                title: 'Образовательные проекты',
                list: [
                    'Практические лекции по продвижению в сфере красоты и здоровья',
                    'Модерация дискуссий и подкастов с участием экспертов отрасли',
                ]
            }
        ]
    }
}

const antropov = {
    name: {
        raw: 'Руслан Антропов',
        komu: 'Руслану Антропову',
    },
    img: {
        src: r_antropov,
    },
    description: 'Организатор конференции Медпервичка',
    about: {
        list: [
            'Опыт и экспертиза в IT и в телекоммуникациях',
            'С 2018 года в SEO',
            'Продюсирование YouTube для бизнеса',
            'Свои проекты в тематике медицина',
        ],
        footer: '',
    },
    uslugi: {
        title: 'Консультирование',
        // header: '\
        //     Стратегия для руководителей и собственников: понимание готовности руководителя к развитию.<br>\
        //     Маркетинг и SEO — это сложный и долгий путь, требующий терпения и последовательности. Важно понимать, насколько руководитель понимает это и готов к изменениям.\
        // ',
        // title: 'Комплексное продвижение медицинских клиник и врачей',
        list: [
            {
                list: [
                    'Стратегия для руководителей и собственников: понимание готовности руководителя к развитию.',
                    'Маркетинг и SEO — это сложный и долгий путь, требующий терпения и последовательности. Важно понимать, насколько руководитель понимает это и готов к изменениям.',
                ]
            },
            {
                title: 'Сайты для медицины',
                list: [
                    'Разработка и доработка сайтов клиник / персональных сайтов врачей.',
                    'Аудит конверсии и юзабилити.',
                ]
            },
            {
                title: 'SEO и аналитика',
                list: [
                    'SEO продвижение в Яндекс и Google.',
                    'SEO-аудит, технические доработки, улучшение структуры.',
                ]
            },
            {
                title: 'Внешние площадки',
                list: [
                    // 'Мед. агрегаторы: ПроДокторов, НаПоправку, СберЗдоровье — от настройки профиля до вывода в ТОП.',
                    'Геосервисы: Яндекс.Бизнес, 2ГИС, Google Maps.',
                    'Яндекс.Врачи: подключение и оптимизация.',
                ]
            },
            {
                title: 'Контент и репутация',
                list: [
                    'Тексты от авторов с медицинским образованием.',
                    'Система сбора отзывов на нужных площадках (Яндекс, Google, агрегаторы).',
                ]
            },
            {
                title: 'Реклама',
                list: [
                    'Контекстная и таргетированная реклама (Яндекс.Директ, Google Ads, соцсети).',
                ]
            }
        ]
    }    
}

const uslugi = {
    list: [
        gladchenko,
        andrishin,
        fyodorova,
        chistilin,
        biryukova,
        antropov,
    ]
}
export default uslugi